/**
 * @generated SignedSource<<638fe39ea11e140b9d51b582e5e999be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: string | null;
  company?: string | null;
  email?: string | null;
  isMacbeeServer?: boolean | null;
  isCrossDomainQuery?: boolean | null;
  isCrossDomainFragment?: boolean | null;
  enableBackendUrlMapping?: boolean | null;
  isSecure?: boolean | null;
  itpUrls?: string | null;
  name?: string | null;
  tel?: string | null;
  userTag?: string | null;
  jsTagManagementEnabled?: boolean | null;
};
export type AccountSettingsPageContainer_Mutation$variables = {
  input: UpdateUserInput;
};
export type AccountSettingsPageContainer_MutationVariables = AccountSettingsPageContainer_Mutation$variables;
export type AccountSettingsPageContainer_Mutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly name: string | null;
      readonly company: string | null;
      readonly tel: string | null;
      readonly email: string;
      readonly itpUrls: string | null;
      readonly userTag: string | null;
      readonly isCrossDomainQuery: boolean;
      readonly isCrossDomainFragment: boolean;
      readonly jsTagManagementEnabled: boolean;
      readonly enableBackendUrlMapping: boolean;
    };
  } | null;
};
export type AccountSettingsPageContainer_MutationResponse = AccountSettingsPageContainer_Mutation$data;
export type AccountSettingsPageContainer_Mutation = {
  variables: AccountSettingsPageContainer_MutationVariables;
  response: AccountSettingsPageContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "company",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tel",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itpUrls",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userTag",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCrossDomainQuery",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCrossDomainFragment",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jsTagManagementEnabled",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableBackendUrlMapping",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSettingsPageContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountSettingsPageContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e543cfac9d0629800c82f29cb399cd4d",
    "id": null,
    "metadata": {},
    "name": "AccountSettingsPageContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation AccountSettingsPageContainer_Mutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      name\n      company\n      tel\n      email\n      itpUrls\n      userTag\n      isCrossDomainQuery\n      isCrossDomainFragment\n      jsTagManagementEnabled\n      enableBackendUrlMapping\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "120d794bf665f6ee0b4be2b26c40d8ab";

export default node;
